// react
import React from "react";
import { FormattedMessage } from "react-intl";

// third-party
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

// application
import StroykaSlick from "../shared/StroykaSlick";

// data stubs
import theme from "../../data/theme";

const slickSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 400,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            },
        },
        {
            breakpoint: 379,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};

function SitePageAboutUs() {
    return (
        <div className="block about-us">
            <Helmet>
                <title>{`About Us — ${theme.name}`}</title>
            </Helmet>

            <div className="about-us__image" style={{ backgroundImage: 'url("images/warehouse-roads.jpg")' }} />
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-xl-10">
                        <div className="about-us__body">
                            <h1 className="about-us__title"><FormattedMessage id="Site.aboutUs" defaultMessage="About Us" /></h1>
                            <div className="about-us__text typography">
                                <p>
                                    <FormattedMessage id="Site.bienvenueChezNoumiCa" defaultMessage="Bienvenue chez noumi.ca, votre partenaire de confiance pour des produits du quotidien. Nous sommes une entreprise spécialisée dans la distribution d’une large gamme d’articles, allant des jouets et jeux aux accessoires lifestyle, en" />
    
                                </p>
                                <p>
                                <FormattedMessage id="Site.decouvrezToutCeQueNoumiDistributionA" defaultMessage="Découvrez tout ce que Noumï Distribution a à offrir et rejoignez-nous dans cette aventure !  "/>

                                </p>
                            </div>
                            {/* <div className="about-us__team">
                                <div className="about-us__teammates teammates">
                                    <StroykaSlick {...slickSettings}>
                                        <div className="teammates__item teammate">
                                            <div className="teammate__avatar">
                                                <img src="images/teammates/teammate-1.jpg" alt="" />
                                            </div>
                                            <div className="teammate__name"><FormattedMessage id="Site.michaelRusso" defaultMessage="Michael Russo" /></div>
                                            <div className="teammate__position text-muted"><FormattedMessage id="Site.chiefExecutiveOfficer" defaultMessage="Chief Executive Officer" /></div>
                                        </div>
                                    </StroykaSlick>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SitePageAboutUs;
